import React from "react"

function Card(props) {
  console.log(props)
  return (
    <div
      className="col-md-2 col-sm-2 small tech-stack"
      style={{ margin: "0 auto" }}
    >
      <div
        style={{
          justifyContent: "center",
        }}
      >
        <img
          src={props.imgsrc}
          alt="..."
          style={{
            width: "50px",
            height: "50px",
            objectFit: "cover",
            margin: "0 auto",
          }}
        />

        <p className="small-icon" style={{ color: "#BBBBBB" }}>
          {props.title}
        </p>
      </div>
    </div>
  )
}

export default Card
